import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/** 官网 */
import homePage from '../views/homePage/index.vue';

const bycxRoutes = [{
  path: '/',
  redirect: '/index',
}, {
  path: '/index',
  name: 'index',
  component: homePage,
  meta: {
    title: '巴运出行'
  }
},];

export default new Router({
  mode: 'history',
  routes: [
    ...bycxRoutes
  ]
})



// WEBPACK FOOTER //
// ./src/bycx/router/index.js